import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import FileUpload from './imagesUploads';
import { config } from './config';
import languageMap from '../languageMap';
import './EventDetails.css';

const EventDetails = (props) => {
  const { event_name, username } = props.location.state || {};
  const selectedLanguage = languageMap.config.selectedLanguage || 'en';

  const [copySuccess, setCopySuccess] = useState('');

  const handleFetchAndCopyLink = async () => {
    try {
      // Example: maybe you do some backend request here,
      // but then you want to create a link to /UploadImages with the query params:
      const shareLink = `${window.location.origin}/gallery-manager?username=${username}&event=${event_name}`;

      // Copy the link
      await navigator.clipboard.writeText(shareLink);
      setCopySuccess(languageMap.copySuccess[selectedLanguage]);
      
      // Optionally clear the success message after N seconds
      setTimeout(() => setCopySuccess(''), 1500);

    } catch (error) {
      console.error('Failed to copy event link:', error);
    }
  };

  return (
    <div className="EventDetails">
      <div className="upload-header">
        <h1>החתונה של ליה ויוסף</h1>
      </div>

      <div className="event-img">
        <img src="/images/0N5A4100.jpg" alt="Decorative" />
      </div>
      <h4 className="event-img">
        {languageMap.welcomePartner[selectedLanguage]}
      </h4>

      <div className="button-group">
        <button onClick={handleFetchAndCopyLink} className="circular-button">
          {languageMap.copyLink[selectedLanguage]}
        </button>

        <FileUpload
          username={username}
          eventName={event_name}
          upload_route={config.apiUrl + '/upload_images'}
        />

        {/* Normal navigation link, if you also want to navigate directly */}
        <Link
          to={{
            pathname: '/UploadImages',
            search: `?username=${username}&event=${event_name}`,
            state: { eventName: event_name, username },
          }}
        >
          <button className="circular-button">
            {languageMap.addNewGuestButton[selectedLanguage]}
          </button>
        </Link>
      </div>

      {copySuccess && (
        <span style={{ marginLeft: '10px', color: 'green' }}>
          {copySuccess}
        </span>
      )}
    </div>
  );
};

export default EventDetails;
